"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFile = void 0;
const react_peg_1 = require("react-peg");
const declaration_1 = require("../declaration");
function TypeFile() {
    const action = ({ body }) => {
        return {
            kind: "TypeFile",
            body
        };
    };
    return (react_peg_1.ReactPeg.createChunk("pattern", { action: action },
        react_peg_1.ReactPeg.createChunk("repeat", { type: "+", label: "body" },
            react_peg_1.ReactPeg.createChunk("or", null,
                react_peg_1.ReactPeg.createChunk(declaration_1.ImportDeclaration, null),
                react_peg_1.ReactPeg.createChunk(declaration_1.TypeVariableDeclaration, null),
                react_peg_1.ReactPeg.createChunk(declaration_1.TypeFunctionDeclaration, null)))));
}
exports.TypeFile = TypeFile;
